import { axiosPost } from '@gsretail/gssm-util'

const API_URL = import.meta.env.VITE_API_URL

/**
 * @description: httpCmSySyscnfFecnfRetrieveFeBuildVer (프론트엔드 빌드 버전 조회)
 * @param {string} bucketSp 시스템코드 (store, supp)
 */
export const httpCmSySyscnfFecnfRetrieveFeBuildVer = (param) => {
  return axiosPost({
    url: API_URL + '/comm/api/cm/sy/syscnf/fe-cnf/retrieve-fe-build-ver',
    data: param
  })
}
